module.exports = __webpack_public_path__ + "img/48.26c63d38.png";